<div class="wrap">
    <div class="amount">
        <div class="amount-in">
            <p translate>
                questionBoard.edit.expense.globalAmount
            </p>
            <div class="text-amount">
                <span class="currency">₪</span>
                <span>{{ amount$() | number }}</span>
            </div>
        </div>
        <div *ngIf="!validateAmount() && isUser" class="amount-error-message">
            <span class="text" translate>questionBoard.edit.expense.warnningAmount</span>
            <svg-icon svgClass="img" src="/assets/images/close.svg"></svg-icon>
        </div>
    </div>
    <div class="body">
        <div class="list">
            <div *ngFor="let answer of answers.controls; let i = index">
                <que-expense-item-display [viewAnswer]="viewAnswer" (deleteExpense)="deleteExpense(i)"
                    [formControl]="answer" [question]="question" [row]="i + 1"
                    [canDelete]="answers.controls.length > 1">
                </que-expense-item-display>
            </div>
        </div>
        <div class="add-expense" (click)="isUser ? addExpense() : null">
            <svg-icon svgClass="svg-img" src="/assets/images/options/add-question.svg"></svg-icon>
            <span translate>questionBoard.edit.expense.addExpense</span>
        </div>
    </div>
</div>